'use strict';

frontendApp.factory('NavigationService', ['$rootScope', function ($rootScope) {

  var _service = {};

  var active = {
    mainNavItem: null,
    subNavItem: null
  };

  var mainNavItems = [];

  _service.addMainNavItem = function (item) {
    mainNavItems.push(item);
  };

  _service.clearMainNav = function () {
    // keep references I guess
    mainNavItems.length = 0;
  };

  _service.getMainNavItems = function () {
    return mainNavItems;
  };

  _service.setActiveTab = function (name, subname) {
    active.mainNavItem = name;
    active.subNavItem = subname;
  };

  _service.clearActiveTab = function () {
    active.mainNavItem = null;
    active.subNavItem = null;
  };

  _service.getActive = function () {
    return active;
  };

  _service.getActiveMainNavItem = function () {
    return active.mainNavItem;
  };

  _service.getActiveSubNavItem = function () {
    return active.subNavItem;
  };

  return _service;

}]);

